module.exports = __webpack_public_path__ + "static/media/inventoryAptNotAvail.47778d50.svg";